<template>
    <Form :model="actionData" id="apply_discuss_form">
        <FormItem prop="title">
            <i-input type="text" placeholder="请输入话题名称(12字以内)" v-model="actionData.discuss_name" key="title"
                :maxlength="12" show-word-limit />
        </FormItem>
        <FormItem prop="icon">
            <div class="apply_discuss_icon_title">请上传话题图标</div>
            <van-uploader v-model="iconList" :max-count="1" :after-read="afterRead" :accept="'image/*'"
                @delete="deleteApplyIcon" class="apply_discuss_uploadimg">
                <van-icon name="plus" color="#868686" size="50" class="plus_icon" />
            </van-uploader>
        </FormItem>
        <FormItem prop="desc">
            <i-input type="textarea" placeholder="话题描述(200字以内)" v-model="actionData.discuss_lead" :rows="5"
                :maxlength="200" />
        </FormItem>
        <FormItem prop="reason">
            <i-input type="textarea" placeholder="话题申请理由..." v-model="actionData.reason" :rows="5" />
        </FormItem>
    </Form>
</template>

<script>
    export default {
        data() {
            return {
                url: 'com/add-applic-discuss',
                iconList: [],
                actionData: {
                    discuss_name: this.selection.discuss_name,
                    discuss_icon: this.selection.discuss_icon,
                    discuss_lead: this.selection.discuss_lead,
                    reason: this.selection.reason,
                    discuss_id: this.selection.discuss_id
                }
            }
        },
        methods: {
            _validate() {
                return new Promise((resolve, reject) => {
                    var {
                        discuss_name,
                        discuss_lead,
                        reason,
                        discuss_icon
                    } = this.actionData

                    if (discuss_name == '') {
                        reject(new Error("请输入话题名称"));
                    } else if (discuss_icon == '') {
                        reject(new Error("请上传话题图标"));
                    } else if (discuss_lead == '') {
                        reject(new Error("请填写话题描述"));
                    } else if (reason == '') {
                        reject(new Error("请填写话题申请理由"));
                    } else {
                        resolve()
                    }
                })
            },
            afterRead(file) {
                var that = this
                this.$HttpRequest('/com/upload-img',file.file).then(rs => {
                    if (rs.data.code == 200) {
                        that.actionData.discuss_icon = rs.data.data.url
                    }
                })
            },
            //删除图标
            deleteApplyIcon() {
                this.iconList = []
                this.actionData.discuss_icon = ''
            }
        },
        watch: {
            'selection.discuss_icon': {
                immediate: true,
                handler(i) {
                    if (i) {
                        this.iconList = [{
                            url: i
                        }]
                    }
                }
            },
            'selection.url': {
                immediate: true,
                handler(u) {
                    if (u) {
                        this.url = u
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    #apply_discuss_form {
        .ivu-form-item {
            margin-bottom: 0.8rem;
            padding-bottom: 0.8rem;
            border-bottom: 1px solid#dcdee2;

            &:nth-last-child(1) {
                border: none;
            }
        }

        .apply_discuss_icon_title {
            font-size: 15px;
        }

        .apply_discuss_uploadimg {
            background-color: #f2f2f2;
            width: 80px;
            height: 80px;
            display: block;

            /deep/.van-uploader__wrapper {
                .van-uploader__input-wrapper {
                    width: 80px;
                    height: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .van-uploader__preview {
                    margin: 0;
                }
            }

            .plus_icon {
                font-weight: 700;
            }
        }
    }
</style>